export enum BracketOperator {
  open = "(",
  close = ")",
}

export enum ServiceType {
  SCORECARD = "scorecard",
  ORCHESTRATION = "orchestration",
}
